<script>
    import Calculator from 'views/components/calculator/Calculator.svelte';
    import Icon from 'views/components/icon/Icon.svelte';

    const { simpleMode = false } = $props()

    function onClick() {
        const container = new BaseView()
        container.addSvelteChildView(
            container.el,
            Calculator,
            { simpleMode }
        )
        Backbone.View.sidebar.showSidebar(
            container,
            window.i18n.gettext('Calculator'),
            320,
            undefined,
            window.innerWidth > 960,
        )
    }
</script>

<button class="calculator-button no-print" onclick={onClick}>
    <Icon name="calculator"></Icon>
    <div class="tooltip">
        {window.i18n.gettext('Calculator')}
    </div>
</button>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.calculator-button {
  box-shadow: 0 10px 30px 0 rgba(18, 45, 64, 0.12);
  position: fixed;
  bottom: 16px;
  right: 64px;
  display: flex;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: hsl(205, 60%, 44%);
  color: #fff;
  transition: all ease-out 0.1s;
  animation: 0.3s fadeIn ease-out;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
}
@media (max-width: 1200px) {
  .calculator-button {
    right: 64px;
    width: 48px;
    height: 48px;
  }
}
.calculator-button:hover {
  background: hsl(205, 58%, 38%);
  transform: scale(1.1);
}
@media (hover: hover) {
  .calculator-button:hover .tooltip {
    display: block;
  }
}
.calculator-button :global(svg) {
  width: 32px;
  height: 32px;
  margin: auto;
}
@media (max-width: 1200px) {
  .calculator-button :global(svg) {
    width: 24px;
    height: 24px;
  }
}
.calculator-button .tooltip {
  display: none;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateX(-100%) translateX(-8px) translateY(-50%);
  padding: 4px 8px;
  border-radius: 8px;
  background: #122d40;
}</style>
